import { render, staticRenderFns } from "./jumbotron.vue?vue&type=template&id=4df9dd05&scoped=true&"
import script from "./jumbotron.vue?vue&type=script&lang=js&"
export * from "./jumbotron.vue?vue&type=script&lang=js&"
import style0 from "./jumbotron.vue?vue&type=style&index=0&id=4df9dd05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df9dd05",
  null
  
)

export default component.exports